/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-08-19 09:42:02
 */
import React, { useState, useEffect} from "react";
import { setApplyCount } from '@/features/user/userSlice';
import DeleteModal from '../../../components/delete-modal';
import { deleteAfterSales } from '@/api/after-sales';
import { orderCountTotal } from '@/api/personal-center';
import OrderCancel from '@/views/personal-center/components/order-cancel';
import './index.scss';
import { message } from "antd";
import {getBuyWay} from '@/utils'
import { dispatch } from "@/redux/store";
interface IProps {
  orderData: any,
  setIsRefresh?:any
}
const ServiceTableMain: React.FC<IProps> = (props) => {
  const { orderData,setIsRefresh } = props;
  const [orderDeleteModal, setOrderDeleteModal] = useState(false);
  const [orderInfo, setOrderInfo] = useState([]);
  const [orderId, setOrderId] = useState(''); // 订单id
  const [cancelFlag, setCancelFlag] = useState(false); // 取消订单
  
  useEffect(() => {
    setOrderInfo(orderData);
  },[orderData])
  // 删除售后弹窗
  const serviceDeleteDialog = (id:string) => {
    setOrderId(id);
    setOrderDeleteModal(true);
    setIsRefresh(false);
  }

  // 删除售后
  const orderDeleteFunc = () => {
    if(orderId !== '') {
      deleteAfterSales(orderId).then((dRes:any) => {
        if(dRes.success) {
          message.success('删除成功！');
          setOrderDeleteModal(false);
          setIsRefresh(true);
          cartCountFunc();
        }else {
          message.error(dRes.message);
        }
      }) 
    }
  }
  // 取消售后
  const cancelOrderDialog = (id:string) => {
    setOrderId(id);
    setCancelFlag(true);
    setIsRefresh(false);
  }
  // 更新数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes:any) => {
      if(oRes.success) {
        dispatch(setApplyCount(oRes.obj?.apply??0));
      }
    })
  }
  return (
    <>
      <div className="service-table-main">
        {
          orderInfo.map((oData:any) => (
            <div className="order-detail" key={oData.id}>
              <p>{oData.createTime}<span>售后单号：{oData.applyNo}</span>订单号：{oData.orderNo}</p>
              <div className="order-table">
                <div className="order-product">
                  {
                    oData.productList.map((pData:any)=> (
                      <div className="order-product-info" key={pData.id}>
                        <div style={{ width: 533 }} className="style-inset inset-name"
                          // title={pData.productName + ' ' + (pData.models.find((ele: any) => ele?.type === 1))?.models}
                          title={pData.productName + ' ' + (pData.models.find((ele: any) => ele?.type === 1))?.models + ' ' + (pData.models.find((ele: any) => ele?.feeType === '2') ? getBuyWay((pData.models.find((ele: any) => ele?.type === 1))?.subscribe[0]?.unit) : '')}
                        >
                          {pData.pmsFiles && <img src={pData.pmsFiles[0]?.url} alt='' onClick={()=>window.open(`/detail?productSn=${pData.productSn}`)} />}
                          <div className="order-info-detail" onClick={()=>window.open(`/detail?productSn=${pData.productSn}`)}>{pData.productName}
                            <span className="modal-show">
                              {
                                pData.models.length > 0 &&
                                <>
                                {(pData.models.find((ele:any)=>ele?.type===1))?.models}  {pData.models.find((ele:any)=>ele?.feeType==='2')&&getBuyWay((pData.models.find((ele:any)=>ele?.type===1))?.subscribe[0]?.unit)}
                                </>
                              }
                              </span>
                          </div>
                        </div>
                        <div style={{width: 144}} className="style-inset">{pData.applyQuantity}</div>
                      </div>
                    ))
                  }
                </div>
                
                <div className="order-operate" style={{height: 120*oData.productList.length}}>
                  <div style={{width: 134}} className="style-inset status-detail">
                    {
                      oData.status === 0 &&
                      <span className="pending">售后处理</span>
                    }
                    {
                      oData.status === 1 &&
                      <span className="complete">售后完成</span>
                    }
                    {
                      oData.status === 2 &&
                      <span className="cancel">已取消</span>
                    }
                    <span onClick={()=>window.open(`/user/as/detail/${oData.id}`)}>售后详情</span>
                  </div>
                  <div style={{width: 103}} className="style-inset cancel-btn">
                    {
                      oData.status === 0 &&
                      <span onClick={()=>cancelOrderDialog(oData.id)}>取消售后</span>
                    }
                    {
                      oData.status === 2 &&
                      <span style={{color: '#999'}} onClick={()=>serviceDeleteDialog(oData.id)}>删除</span>
                    }
                    {
                      oData.status === 1 &&
                      <span style={{color: '#000'}}>-</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          ))
        }
       
      </div>
      <DeleteModal
        showDeleteModal={orderDeleteModal}
        setShowDeleteModal={setOrderDeleteModal}
        handleDelete={orderDeleteFunc}
        title='删除提醒'
        content='删除后该售后申请将从列表中移除，请确认是否删除？'
        okText='是'
        cancelText='否'
      />
      <OrderCancel 
        cancelFlag={cancelFlag} 
        setCancelFlag={setCancelFlag}
        orderId={orderId}
        setIsRefresh={setIsRefresh}
        cancelType={1}
      />
    </>   
  )
}

export default ServiceTableMain;